// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDdfU0Y7DOr4ItDObYr1qSPvIRSdAn3kL4",
  authDomain: "survival-coding.firebaseapp.com",
  projectId: "survival-coding",
  storageBucket: "survival-coding.appspot.com",
  messagingSenderId: "987958077563",
  appId: "1:987958077563:web:10519822961ce583091ade",
  measurementId: "G-R3D3X943LG",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics };